import * as React from "react";
import "./user.css";
import "../../style/fonts.css";
import translate from "../../translations/i18n";
import Avatar from "../profileTop/avatar";
import moment from "moment";
import { Link } from "react-router-dom";
import { calculateSmokeless } from "../../functions/calculateSmokeless";

export interface Props {
  user: any;
}

class FollowedUser extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    let avatar;
    try {
      avatar = JSON.parse(this.props.user.avatar);
    } catch (e) {
      console.log(e)
    }
    if (this.props.user) {
      const linkToProfile = "/profile/" + this.props.user.uid;

      const daysString = calculateSmokeless(this.props.user.start_date);

      return (
        <div className="FOLLOWED_USER_CONT">
          <Link to={linkToProfile}>
            <div className="FOLLOWED_USER_CONT_CARD2">
              {avatar && (
                <div className="AVATAR_USER_CARD">
                  <Avatar avatar={avatar} width={36} height={48} />
                </div>
              )}
              <div className="FOLLOWED_USER_INFO">
                <div className="FOLLOWED_USER_DAYS">
                  <div className="SMALL_TEXT1">{daysString}</div>
                </div>
                <div className="FOLLOWED_USER_USERNAME">
                  <div className="TITLE_4">{this.props.user.username}</div>
                </div>
              </div>
            </div>
          </Link>
        </div>
      );
    } else return null;
  }
}

export default FollowedUser;



// WEBPACK FOOTER //
// ./src/components/searchUser/User.tsx